import banner from './banner.png'
import goods1 from './goods1.png'
import goods2 from './goods2.png'
import goods3 from './goods3.png'
let goodsList = [
    {
        imageUrl: goods1,
        linkUrl: ''
    },
    {
        imageUrl: goods2,
        linkUrl: ''
    },
    {
        imageUrl: goods3,
        linkUrl: ''
    }
]
export {
    banner as banner,
    goodsList as goodsList
}